import React, { useEffect, useState } from 'react'
import FontFaceObserver from 'fontfaceobserver'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import { normalize } from 'polished'
import { StaticQuery, graphql } from 'gatsby'
import { Box } from 'rebass'
import Menu from './Menu'
import { Background } from './Background'
import { LoadingOverlay } from './LoadingOverlay'

const GlobalStyles = createGlobalStyle`
${normalize};
body {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
  min-height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.5;
  text-rendering: optimizeSpeed;
  font-display: swap;
}
html, body, div, article, section, main, footer, header, figcaption, form, input, fieldset, legend, pre, code, a, h1, h2, h3, h4, h5, h6, p, ul, ol, li {
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: inherit;
}
p {
  margin: 0 0 1em;
}
figure {
  margin: 0;
}
`
// eslint-disable-next-line
const Layout = ({ children, invertMenuLogo, noPadding }) => { 
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    const font = new FontFaceObserver('Rhode Med Extd')
    font.load()
      .finally(() => {
        setLoaded(true)
      })
      .catch(console.error)
  }, [])
  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              title
            }
          }
          menu: allContentfulNavigations {
            edges {
              node {
                navigationItems {
                  ... on ContentfulLinkItem {
                    contentful_id
                    title
                    slug
                    externalUrl
                  }
                  ... on ContentfulPage {
                    contentful_id
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      `}
      render={({ site, menu: { edges = [{ node: {} }] } }) => (
        <>
          <GlobalStyles />
          <LoadingOverlay fadeOut={loaded} />
          <Box px={noPadding ? [] : [3, 3, 4]}>{children}</Box>
          <Menu invertLogo={invertMenuLogo} title={site.siteMetadata.title} items={edges[0].node.navigationItems} />
          <Background />
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  invertMenuLogo: PropTypes.bool,
}

export default Layout
